export const DAILY_PRIZE_STATUS = 'DAILY_PRIZE_STATUS'
export const DAILY_PRIZE_GUESS = 'DAILY_PRIZE_GUESS'
export const DAILY_PRIZE_HISTORY = 'DAILY_PRIZE_HISTORY'
export const DAILY_PRIZE_GUESSES = 'DAILY_PRIZE_GUESSES'
export const DAILY_PRIZE_GUESSES_ALL = 'DAILY_PRIZE_GUESSES_ALL'
export const DAILY_PRIZE_POOL = 'DAILY_PRIZE_POOL'